module.exports = __webpack_public_path__ + "img/addIcon.0d1fcd40.png";